<div class="logo-splash-container" [class.fade-out-bck]="fadeOut" (animationend)="onFadeOutEnd()">
  <div class="logo-splash-svg-container" *ngIf="delayLogoAnimation && showLogo">
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 180 180"
      preserveAspectRatio="xMidYMid meet"
      class="logo-svg"
      role="img"
      aria-label="Arkik Logo"
    >
      <defs>
        <style>
          .cls-1 {
            fill: #2d2d2d;
          }
          .cls-2 {
            fill: #09f;
          }
          .cls-3 {
            fill: url(#linear-gradient);
          }
          .cls-4 {
            fill: #6cf;
          }
          .cls-5 {
            fill: url(#linear-gradient-2);
          }
        </style>
        <linearGradient
          id="linear-gradient"
          x1="4079.44"
          y1="1400.34"
          x2="4079.44"
          y2="1356.85"
          gradientTransform="translate(1472.17 -4057.72) rotate(90)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#09f"></stop>
          <stop offset="1" stop-color="#069"></stop>
        </linearGradient>
        <linearGradient
          id="linear-gradient-2"
          x1="4188.52"
          y1="1390.44"
          x2="4188.52"
          y2="1356.93"
          gradientTransform="translate(-4090.03 -1242.89)"
          xlink:href="#linear-gradient"
        ></linearGradient>
      </defs>
      <g id="Layer_2" data-name="Layer 2">
        <path
          class="cls-2"
          d="M179.13,130.73a15.58,15.58,0,0,1-15.58,15.58h-54.8c-1.16.11-66,.27-67.19,0h0A41.54,41.54,0,0,1,0,104.77V41.54A41.54,41.54,0,0,1,41.54,0h63.39a41.54,41.54,0,0,1,41.54,41.54V105a40.82,40.82,0,0,1-1.28,10.19h18.36a15.58,15.58,0,0,1,15.58,15.59ZM115.32,41.54a10.4,10.4,0,0,0-10.39-10.37H41.54A10.38,10.38,0,0,0,31.17,41.54v63.23a10.38,10.38,0,0,0,10.37,10.37h73.77Z"
        ></path>
        <path
          class="cls-3"
          d="M71.94,31.2,71.83,0h35l8.33,19.23.21,24.22s.26-5.7-2.74-8.91a10.13,10.13,0,0,0-7.36-3.34Z"
        ></path>
        <path
          class="cls-4"
          d="M105,0H52.64c33.92,0,62.18,19.29,62.67,40.86,0,.23,0,.45,0,.68V164.42A15.59,15.59,0,0,0,130.9,180h0a15.59,15.59,0,0,0,15.59-15.58V41.54A41.54,41.54,0,0,0,105,0Z"
        ></path>
        <rect
          class="cls-5"
          x="82.83"
          y="114.04"
          width="31.31"
          height="33.51"
          transform="translate(229.29 32.31) rotate(90)"
        ></rect>
      </g>
    </svg>

    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="200 0 384 180"
      preserveAspectRatio="xMidYMid meet"
      class="text-logo-svg"
      role="img"
      aria-label="Arkik Text Logo"
      (animationend)="onTextAnimationEnd()"
    >
      <g id="Layer_2" data-name="Layer 2">
        <path
          class="cls-1"
          d="M219.54,147.21,260,36.62h22.75l40.44,110.59H301.69l-8.85-25.59H249.71l-9,25.59Zm35.7-41.39h32.07l-16.11-46Z"
        ></path>
        <path
          class="cls-1"
          d="M330.76,147.21V68.85h18l1.89,14.69a32.9,32.9,0,0,1,11.61-12.08A32.49,32.49,0,0,1,379.57,67V88.28h-5.68A32.07,32.07,0,0,0,362,90.34a16,16,0,0,0-8.14,7.11Q351,102.51,351,111.51v35.7Z"
        ></path>
        <path
          class="cls-1"
          d="M387.15,147.21V33.46h20.23v67.15l27.8-31.76h24l-32.06,35.7,37.28,42.66H439.13l-31.75-39.34v39.34Z"
        ></path>
        <path
          class="cls-1"
          d="M481.63,56.69a12.8,12.8,0,0,1-9.09-3.32A11,11,0,0,1,469,45a10.71,10.71,0,0,1,3.55-8.29,14.36,14.36,0,0,1,18.17,0A10.71,10.71,0,0,1,494.27,45a11,11,0,0,1-3.56,8.38A12.8,12.8,0,0,1,481.63,56.69Zm-10.11,90.52V68.85h20.22v78.36Z"
        ></path>
        <path
          class="cls-1"
          d="M506.75,147.21V33.46H527v67.15l27.8-31.76h24l-32.07,35.7L584,147.21H558.72L527,107.87v39.34Z"
        ></path>
      </g>
    </svg>
  </div>
</div>
